<script>
import { SocialSvg } from "./SocialIcon";
export default {
    props: {
        name: {
            type: String
        },
        description: {
            type: String
        },
        image_profile: {
            type: String
        },
        type: {
            type: String,
            default: "column",
            validator(value) {
                return value === "column" || value === "row";
            }
        },
        button: {
            type: Array,
            default: () => [
                {
                    title: "",
                    url: ""
                }
            ]
        },
        is_display_profile: {
            type: Boolean | Number,
            default: true
        },
        social_icons: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            social_svg: SocialSvg
        };
    }
};
</script>
<template>
    <div class="tw-m-auto">
        <div class="linktree-card link-tree-theme-default">
            <div class="tw-flex tw-flex-col">
                <div
                    class="tw-flex tw-flex-col tw-mb-8"
                    v-if="is_display_profile"
                >
                    <img
                        class="tw-w-24 tw-h-24 tw-rounded-full tw-mx-auto tw-mb-4
                link-tree-profile"
                        :src="
                            `${image_profile ||
                                '/images/placeholder/avatar.jpeg'}`
                        "
                        alt=""
                    />
                    <div class="tw-text-xl link-tree-name tw-text-center">
                        {{ name }}
                    </div>
                    <div
                        class="link-tree-description tw-text-center tw-text-sm"
                    >
                        {{ description }}
                    </div>
                </div>
                <div
                    :class="
                        `button-container tw-gap-4 tw-grid ${
                            type == 'column'
                                ? 'tw-grid-cols-1'
                                : 'tw-grid-cols-2'
                        }`
                    "
                >
                    <div
                        v-for="(item, index) in button"
                        :key="index"
                        class="button-item tw-w-full tw-text-center tw-flex-1 tw-py-4 tw-px-5 tw-cursor-pointer"
                    >
                        <a
                            :href="item.url"
                            target="_blank"
                            class="tw-w-full tw-h-full no-underline tw-text-black"
                        >
                            {{ item.title || "..." }}
                        </a>
                    </div>
                </div>
                <div
                    class="icon-socials-container tw-mt-6 tw-w-full tw-flex tw-justify-center tw-gap-4"
                >
                    <a
                        class="icon-socials-item tw-w-8 tw-h-8"
                        v-for="(item, index) in social_icons"
                        :key="index"
                        :href="item.url"
                        target="_blank"
                    >
                        <div
                            class="social_svg"
                            v-html="social_svg[item.type]"
                        ></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
.linktree-card {
    width: 100%;
    min-height: 695px;
    padding: 64px 16px 32px;
    background: rgb(251, 251, 236);
    border-radius: 8px;
    margin: auto;
    @media (min-width: 768px) {
        width: 393px;
    }
}
.link-tree {
    &-theme-default {
        background: #eee;
        border: 1px solid rgb(203, 203, 203);
        .button-container {
            .button-item {
                background: rgb(249, 249, 249);
                border: 1px solid black;
                border-radius: 4px;
                transition: all 0.2s ease;
                &:hover {
                    background: #ddd;
                }
            }
            .icon-socials-item {
                .social_svg > svg {
                    width: 32px;
                    height: 32px;
                }
            }
        }
    }
}
</style>
